<template>
  <div class="tbe-product">
    <h4 class="tbe-product__title">{{ product.title }}</h4>
    <p v-if="product.description">{{ product.description }}</p>
  </div>
</template>

<script>
  import { useStore } from 'vuex'
  import { computed } from 'vue'

  export default {
    name: 'tbeProduct',

    setup() {
      const store = useStore()

      const product = computed(() => store.state.booking.product)

      return { product }
    }
  }
</script>

<style lang="scss" scoped>
  .tbe-product {
    &__title {
      font-size: 24px;
    }
  }
</style>
